// extracted by mini-css-extract-plugin
module.exports = {"tertiary-icon":"tertiary-icon__+tgJG","icon":"icon__ENzBC"};